import React from "react";

export const images = [
  {
    url: "/images/services/ove.png",
    id: "item1",
    class: "",
    alt: "Ove"
  },
  {
    url: "/images/services/tippmee_mobile.png",
    id: "item2",
    alt: "TippMee",
    class: ""
  },
  {
    url: "/images/services/seconddate.png",
    alt: "Second Date",
    id: "item3",
    class: ""
  },
  {
    url: "/images/services/blockchain-mobile.png",
    alt: "Blockchain",
    id: "item4",
    class: ""
  },
  {
    url: "/images/services/gather.png",
    alt: "Fintech",
    id: "item5",
    class: ""
  },
  {
    url: "/images/services/crm-mobile.png",
    alt: "CRM",
    id: "item6",
    class: ""
  },
  {
    url: "/images/services/n1-mobile-hero.png",
    alt: "N1 Mobile",
    id: "item7",
    class: ""
  },
  {
    url: "/images/services/arcc-mobile.png",
    alt: "ARCC",
    id: "item8",
    class: ""
  },
  {
    url: "/images/services/ai-mobile.png",
    alt: "Ideon",
    id: "item9",
    class: ""
  }
];
export const services = [
  {
    id: "item1",
    title: "UI/UX design",
    link: "/ui-ux-design",
    class: "lg:active",
    icon: (
      <svg
        width="36"
        height="35"
        viewBox="0 0 36 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="18.0498" cy="17.8495" r="17.1602" fill="#B1FA63" />
        <path
          d="M9.86241 26.1942L16.2264 19.8302M24.2404 17.0002L22.3354 22.7162C22.3049 22.8076 22.2528 22.8904 22.1835 22.9574C22.1142 23.0244 22.0298 23.0737 21.9374 23.1012L10.2594 26.5732C10.1542 26.6045 10.0424 26.6063 9.93628 26.5784C9.83012 26.5505 9.73364 26.4941 9.65733 26.4152C9.58103 26.3363 9.52782 26.238 9.5035 26.131C9.47918 26.024 9.48468 25.9123 9.51941 25.8082L13.3114 14.4342C13.3386 14.3526 13.383 14.2777 13.4417 14.2147C13.5003 14.1517 13.5719 14.1021 13.6514 14.0692L19.0384 11.8512C19.1479 11.806 19.2684 11.7942 19.3846 11.8173C19.5008 11.8405 19.6076 11.8975 19.6914 11.9812L24.0954 16.3862C24.1742 16.465 24.2295 16.5642 24.2551 16.6726C24.2807 16.7811 24.2756 16.8945 24.2404 17.0002Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.9694 8.77422L27.3334 11.1382C27.511 11.3082 27.6529 11.5119 27.7508 11.7375C27.8486 11.963 27.9004 12.2058 27.9031 12.4517C27.9059 12.6975 27.8594 12.9414 27.7666 13.1691C27.6738 13.3967 27.5364 13.6036 27.3626 13.7774C27.1887 13.9512 26.9819 14.0886 26.7542 14.1814C26.5266 14.2743 26.2827 14.3207 26.0368 14.318C25.791 14.3153 25.5482 14.2635 25.3226 14.1656C25.0971 14.0678 24.8933 13.9259 24.7234 13.7482L22.3584 11.3842C22.0248 11.0356 21.841 10.5702 21.8464 10.0877C21.8517 9.60518 22.0457 9.14396 22.3869 8.80277C22.7281 8.46157 23.1894 8.26753 23.6718 8.2622C24.1543 8.25686 24.6207 8.44066 24.9694 8.77422Z"
          fill="black"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3474 17.7082C18.2091 17.5649 18.0435 17.4506 17.8605 17.372C17.6775 17.2934 17.4807 17.252 17.2815 17.2503C17.0824 17.2486 16.8848 17.2865 16.7005 17.3619C16.5162 17.4374 16.3487 17.5487 16.2078 17.6896C16.067 17.8304 15.9556 17.9979 15.8802 18.1822C15.8048 18.3666 15.7668 18.5641 15.7686 18.7633C15.7703 18.9624 15.8117 19.1593 15.8903 19.3423C15.9689 19.5253 16.0832 19.6908 16.2264 19.8292C16.5093 20.1024 16.8882 20.2536 17.2815 20.2502C17.6748 20.2468 18.051 20.089 18.3292 19.8109C18.6073 19.5328 18.765 19.1566 18.7684 18.7633C18.7719 18.37 18.6207 17.9911 18.3474 17.7082Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
  {
    id: "item2",
    title: "Web development",
    link: "/web-development",
    class: "",
    icon: (
      <svg
        width="36"
        height="35"
        viewBox="0 0 36 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="18.0498" cy="17.1602" r="17.1602" fill="#B1FA63" />
        <g clipPath="url(#clip0_1474_509)">
          <path
            d="M25.6813 9.16663C26.2338 9.16663 26.7638 9.38612 27.1545 9.77682C27.5452 10.1675 27.7646 10.6974 27.7646 11.25V23.75C27.7646 24.3025 27.5452 24.8324 27.1545 25.2231C26.7638 25.6138 26.2338 25.8333 25.6813 25.8333H11.098C10.5454 25.8333 10.0155 25.6138 9.62484 25.2231C9.23414 24.8324 9.01465 24.3025 9.01465 23.75V11.25C9.01465 10.6974 9.23414 10.1675 9.62484 9.77682C10.0155 9.38612 10.5454 9.16663 11.098 9.16663H25.6813ZM25.6813 15.4166H11.098V22.7083C11.098 22.9634 11.1917 23.2097 11.3612 23.4003C11.5308 23.591 11.7644 23.7128 12.0178 23.7427L12.1396 23.75H24.6396C24.8948 23.7499 25.141 23.6563 25.3317 23.4867C25.5224 23.3172 25.6442 23.0836 25.674 22.8302L25.6813 22.7083V15.4166ZM12.1396 11.25C11.8634 11.25 11.5984 11.3597 11.4031 11.5551C11.2077 11.7504 11.098 12.0154 11.098 12.2916C11.098 12.5679 11.2077 12.8328 11.4031 13.0282C11.5984 13.2235 11.8634 13.3333 12.1396 13.3333C12.4159 13.3333 12.6809 13.2235 12.8762 13.0282C13.0716 12.8328 13.1813 12.5679 13.1813 12.2916C13.1813 12.0154 13.0716 11.7504 12.8762 11.5551C12.6809 11.3597 12.4159 11.25 12.1396 11.25ZM15.2646 11.25C14.9884 11.25 14.7234 11.3597 14.5281 11.5551C14.3327 11.7504 14.223 12.0154 14.223 12.2916C14.223 12.5679 14.3327 12.8328 14.5281 13.0282C14.7234 13.2235 14.9884 13.3333 15.2646 13.3333C15.5409 13.3333 15.8059 13.2235 16.0012 13.0282C16.1966 12.8328 16.3063 12.5679 16.3063 12.2916C16.3063 12.0154 16.1966 11.7504 16.0012 11.5551C15.8059 11.3597 15.5409 11.25 15.2646 11.25ZM18.3896 11.25C18.1134 11.25 17.8484 11.3597 17.6531 11.5551C17.4577 11.7504 17.348 12.0154 17.348 12.2916C17.348 12.5679 17.4577 12.8328 17.6531 13.0282C17.8484 13.2235 18.1134 13.3333 18.3896 13.3333C18.6659 13.3333 18.9309 13.2235 19.1262 13.0282C19.3216 12.8328 19.4313 12.5679 19.4313 12.2916C19.4313 12.0154 19.3216 11.7504 19.1262 11.5551C18.9309 11.3597 18.6659 11.25 18.3896 11.25Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_1474_509">
            <rect
              width="25"
              height="25"
              fill="white"
              transform="translate(4.88965 5)"
            />
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    id: "item3",
    title: "App development",
    link: "/app-development",
    class: "",
    icon: (
      <svg
        width="36"
        height="35"
        viewBox="0 0 36 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="17.1602" cy="17.1602" r="17.1602" fill="#B1FA63" />
        <path
          d="M25.1134 20.2887C25.1637 20.1906 25.1637 20.097 25.2182 19.9995C26.453 15.4602 23.5159 10.1513 18.4636 7.35425C20.6788 10.1513 21.5551 13.4836 20.7829 16.4762C20.7218 16.7406 20.6353 16.9992 20.5243 17.2489C20.3826 17.1745 20.2448 17.0937 20.1114 17.0069C20.1114 17.0069 15.1121 14.1123 9.75089 9.04166C9.59645 8.89706 12.6383 13.0962 16.0387 16.4285C14.4413 15.5583 9.90533 12.5185 7.06821 10.0577C7.37709 10.5851 7.84385 11.1164 8.30717 11.6483C10.6768 14.4957 13.7725 17.9719 17.4825 20.6244C14.8536 22.124 11.1946 22.2182 7.48189 20.6244C6.55526 20.2416 5.77962 19.7568 4.90332 19.1791C6.45115 21.4481 8.87459 23.5222 11.762 24.6325C15.2169 26.0339 18.7207 25.9365 21.2455 24.6325H21.3C21.4 24.5854 21.5048 24.5344 21.6089 24.4408C22.8444 23.8591 25.2678 23.2343 26.6067 25.6473C26.9701 26.3231 27.6382 23.1865 25.1134 20.2887Z"
          fill="#030000"
        />
      </svg>
    )
  },
  {
    id: "item4",
    title: "Blockchain",
    link: "/blockchain",
    class: "",
    icon: (
      <svg
        width="36"
        height="35"
        viewBox="0 0 36 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="18.0498" cy="17.5097" r="17.1602" fill="#B1FA63" />
        <path
          d="M22.7736 17.1596C23.7637 16.655 24.3825 15.7659 24.2373 14.2857C24.0421 12.2624 22.2952 11.5849 20.0901 11.3927L20.089 8.94702C20.0895 8.93919 20.0936 8.93244 20.0936 8.92434C20.0936 8.73777 19.9424 8.58684 19.7558 8.58657H18.7263C18.6369 8.58665 18.5511 8.62223 18.4878 8.68552C18.4246 8.74881 18.3891 8.83461 18.3891 8.92407H18.3813L18.3826 11.3195C17.9333 11.3195 17.4743 11.3284 17.0186 11.3379L17.0178 8.95377C17.0186 8.94351 17.0237 8.9346 17.0237 8.92407C17.0237 8.7375 16.8725 8.58657 16.6859 8.5863H15.6564C15.5669 8.58638 15.4812 8.62196 15.4179 8.68525C15.3547 8.74854 15.3192 8.83434 15.3192 8.9238L15.3195 8.92461H15.3111L15.3116 11.3932C14.9417 11.4008 14.5786 11.4086 14.2243 11.4086L14.2241 11.3997H11.868V11.4032C11.8237 11.4032 11.7797 11.4119 11.7387 11.4289C11.6977 11.4458 11.6605 11.4707 11.6291 11.5021C11.5978 11.5334 11.5729 11.5707 11.5559 11.6117C11.539 11.6527 11.5302 11.6966 11.5303 11.741V12.882C11.5303 13.0686 11.6815 13.2198 11.868 13.2198L11.8694 13.2195V13.2246C11.8694 13.2246 13.1308 13.2001 13.1098 13.2225C13.8015 13.2227 14.027 13.6242 14.0926 13.9706L14.0939 17.1683L14.0942 17.1804L14.0955 21.6589C14.0653 21.8765 13.9373 22.224 13.454 22.2248C13.4759 22.244 12.2123 22.2245 12.2123 22.2245L12.212 22.2262C12.2099 22.2262 12.2082 22.2248 12.2061 22.2248C12.0438 22.2248 11.9148 22.3415 11.8821 22.494L11.8683 22.4932L11.5573 23.8888L11.5646 23.8902C11.5632 23.9026 11.5573 23.9134 11.5573 23.9264C11.5573 24.1056 11.6982 24.249 11.8748 24.2601L11.874 24.2652L14.0969 24.2644C14.5105 24.2644 14.9177 24.2711 15.3173 24.2736L15.3192 26.7743H15.32C15.32 26.9606 15.4712 27.1118 15.6578 27.1118H16.6873C16.7768 27.1117 16.8625 27.076 16.9258 27.0127C16.989 26.9494 17.0245 26.8635 17.0245 26.774H17.025L17.024 24.3038C17.4924 24.3133 17.9457 24.3168 18.3885 24.3157L18.3891 26.7743H18.3899C18.3902 26.9606 18.5411 27.1118 18.7274 27.1118H19.7569C19.8464 27.1117 19.9322 27.076 19.9954 27.0127C20.0586 26.9494 20.0941 26.8635 20.0941 26.774L20.0963 26.7738L20.0958 24.2771C22.9672 24.111 24.9771 23.3869 25.2255 20.6899C25.4258 18.5188 24.4039 17.55 22.7736 17.1596ZM17.0591 13.3459C18.0232 13.3453 21.0521 13.0375 21.0532 15.0501C21.0534 16.9801 18.0243 16.756 17.0601 16.7565L17.0591 13.3459ZM17.062 22.2383L17.0612 18.4775C18.219 18.4775 21.8491 18.1432 21.8499 20.3553C21.8516 22.4765 18.2198 22.2364 17.062 22.2383Z"
          fill="black"
        />
      </svg>
    )
  },
  {
    id: "item5",
    title: "Fintech & Accounting",
    link: "/fintech-accounting",
    class: "",
    icon: (
      <svg
        width="36"
        height="35"
        viewBox="0 0 36 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="18.0498" cy="17.3446" r="17.1602" fill="#B1FA63" />
        <path
          d="M12.5664 21.5873L9.56641 24.5273V16.0873H12.5664M17.5664 19.7473L15.9964 18.4073L14.5664 19.7273V12.0873H17.5664M22.5664 18.0873L19.5664 21.0873V8.08728H22.5664M25.3764 17.8973L23.5664 16.0873H28.5664V21.0873L26.7764 19.2973L19.5664 26.4473L16.0964 23.4273L12.3164 27.0873H9.56641L16.0364 20.7473L19.5664 23.7273"
          fill="black"
        />
      </svg>
    )
  },
  {
    id: "item6",
    title: "CRM Development",
    link: "/crm-development",
    class: "",
    icon: (
      <svg
        width="36"
        height="35"
        viewBox="0 0 36 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="18.0498" cy="17.1796" r="17.1602" fill="#B1FA63" />
        <path
          d="M16.5664 8.92224V14.9222C16.5664 16.0272 14.5514 16.9222 12.0664 16.9222C9.58141 16.9222 7.56641 16.0272 7.56641 14.9222V8.92224"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5664 11.9222C16.5664 13.0272 14.5514 13.9222 12.0664 13.9222C9.58141 13.9222 7.56641 13.0272 7.56641 11.9222M21.5664 7.92224H24.5664C25.0968 7.92224 25.6055 8.13295 25.9806 8.50803C26.3557 8.8831 26.5664 9.39181 26.5664 9.92224V12.9222M13.5664 25.9222H10.5664C10.036 25.9222 9.52727 25.7115 9.15219 25.3365C8.77712 24.9614 8.56641 24.4527 8.56641 23.9222V20.9222M16.5664 8.92224C16.5664 10.0272 14.5514 10.9222 12.0664 10.9222C9.58141 10.9222 7.56641 10.0272 7.56641 8.92224C7.56641 7.81724 9.58141 6.92224 12.0664 6.92224C14.5514 6.92224 16.5664 7.81724 16.5664 8.92224Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.0664 21.9222C24.4471 21.9222 25.5664 20.803 25.5664 19.4222C25.5664 18.0415 24.4471 16.9222 23.0664 16.9222C21.6857 16.9222 20.5664 18.0415 20.5664 19.4222C20.5664 20.803 21.6857 21.9222 23.0664 21.9222Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.5664 26.9222H18.5664C18.5664 26.3313 18.6828 25.7461 18.9089 25.2002C19.1351 24.6542 19.4666 24.1581 19.8844 23.7403C20.3023 23.3224 20.7984 22.9909 21.3443 22.7648C21.8903 22.5386 22.4755 22.4222 23.0664 22.4222C23.6574 22.4222 24.2425 22.5386 24.7885 22.7648C25.3344 22.9909 25.8305 23.3224 26.2484 23.7403C26.6663 24.1581 26.9977 24.6542 27.2239 25.2002C27.45 25.7461 27.5664 26.3313 27.5664 26.9222Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
  {
    id: "item7",
    title: "Testing & Auditing",
    link: "/testing-auditing",
    class: "",
    icon: (
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="18.0498" cy="18.0146" r="17.1602" fill="#B1FA63" />
        <path
          d="M27.0146 18.3544V22.6669H9.76465V11.1669H18.3896V9.72937H9.76465C9.3834 9.72937 9.01777 9.88082 8.74818 10.1504C8.4786 10.42 8.32715 10.7856 8.32715 11.1669V22.6669C8.32715 23.0481 8.4786 23.4138 8.74818 23.6833C9.01777 23.9529 9.3834 24.1044 9.76465 24.1044H15.5146V26.9794H12.6396V28.4169H24.1396V26.9794H21.2646V24.1044H27.0146C27.3959 24.1044 27.7615 23.9529 28.0311 23.6833C28.3007 23.4138 28.4521 23.0481 28.4521 22.6669V18.3544H27.0146ZM19.8271 26.9794H16.9521V24.1044H19.8271V26.9794Z"
          fill="black"
        />
        <path
          d="M21.9834 17.6356L18.3896 14.0706L19.5325 12.9422L21.9834 15.3716L27.3093 10.0887L28.4521 11.2244L21.9834 17.6356Z"
          fill="black"
        />
      </svg>
    )
  },
  {
    id: "item8",
    title: "Ecommerce & Shopify",
    link: "/ecommerce-shopify",
    class: "",
    icon: (
      <svg
        width="36"
        height="35"
        viewBox="0 0 36 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="18.0498" cy="17.6845" r="17.1602" fill="#B1FA63" />
        <g clipPath="url(#clip0_1474_550)">
          <path
            d="M14.8896 14.3993V10.8993C14.8896 8.96554 16.4603 7.39929 18.3896 7.39929C20.3234 7.39929 21.8896 8.96992 21.8896 10.8993V14.3993M11.3896 12.6493H25.3896V26.6493H11.3896V12.6493Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1474_550">
            <rect
              width="21"
              height="21"
              fill="white"
              transform="translate(7.88965 6.52429)"
            />
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    id: "item9",
    title: "Al Development",
    link: "/ai-development",
    class: "",
    icon: (
      <svg
        width="36"
        height="35"
        viewBox="0 0 36 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="18.0498" cy="17.5194" r="17.1602" fill="#B1FA63" />
        <g clipPath="url(#clip0_1474_554)">
          <path
            d="M24.0664 15.5171C24.0664 15.5611 24.0664 15.6061 24.0634 15.6501C23.7813 15.3994 23.4168 15.2613 23.0394 15.2621C22.8774 15.2621 22.7194 15.2871 22.5664 15.3361V11.0121C22.5664 10.8132 22.4874 10.6224 22.3468 10.4818C22.2061 10.3411 22.0153 10.2621 21.8164 10.2621H13.3164C13.1175 10.2621 12.9268 10.3411 12.7861 10.4818C12.6455 10.6224 12.5664 10.8132 12.5664 11.0121V15.5171C12.5664 15.9311 12.9024 16.2671 13.3164 16.2671H21.5924L21.5824 16.2921L21.5794 16.3041L21.1294 17.6881L21.1194 17.7141C21.1134 17.7319 21.1071 17.7495 21.1004 17.7671H13.3164C12.7197 17.7671 12.1474 17.53 11.7254 17.1081C11.3035 16.6861 11.0664 16.1138 11.0664 15.5171V11.0121C11.0664 10.4153 11.3035 9.84305 11.7254 9.42109C12.1474 8.99914 12.7197 8.76208 13.3164 8.76208H16.8164V8.01208C16.8165 7.8307 16.8823 7.65547 17.0016 7.51886C17.1209 7.38225 17.2857 7.29351 17.4654 7.26908L17.5664 7.26208C17.7478 7.26213 17.923 7.3279 18.0597 7.44723C18.1963 7.56656 18.285 7.73135 18.3094 7.91108L18.3164 8.01208L18.3154 8.76208H21.8154C22.4122 8.76208 22.9845 8.99914 23.4064 9.42109C23.8284 9.84305 24.0654 10.4153 24.0654 11.0121L24.0664 15.5171ZM18.6094 19.2981L18.7214 19.2621H11.8204C11.2237 19.2621 10.6514 19.4991 10.2294 19.9211C9.80749 20.3431 9.57043 20.9153 9.57043 21.5121V22.4191C9.57034 22.9591 9.68689 23.4929 9.91212 23.9837C10.1374 24.4746 10.466 24.911 10.8754 25.2631C12.4384 26.6061 14.6774 27.2631 17.5664 27.2631C19.6424 27.2631 21.3834 26.9241 22.7794 26.2351C22.5139 26.1848 22.2662 26.0657 22.061 25.8897C21.8559 25.7137 21.7005 25.4869 21.6104 25.2321L21.6064 25.2201L21.5764 25.1271C20.4904 25.5491 19.1564 25.7631 17.5664 25.7631C15.0074 25.7631 13.1114 25.2071 11.8534 24.1251C11.6078 23.9139 11.4107 23.6521 11.2755 23.3576C11.1404 23.0632 11.0704 22.7431 11.0704 22.4191V21.5121C11.0704 21.3132 11.1495 21.1224 11.2901 20.9818C11.4308 20.8411 11.6215 20.7621 11.8204 20.7621H17.5664V20.7591C17.5663 20.4395 17.6655 20.1278 17.8502 19.867C18.0349 19.6062 18.296 19.4091 18.5974 19.3031L18.6094 19.2981ZM16.5654 13.0121C16.5702 12.845 16.5413 12.6787 16.4807 12.523C16.42 12.3673 16.3287 12.2253 16.2122 12.1054C16.0957 11.9856 15.9564 11.8903 15.8024 11.8253C15.6485 11.7602 15.4831 11.7267 15.3159 11.7267C15.1488 11.7267 14.9834 11.7602 14.8294 11.8253C14.6755 11.8903 14.5361 11.9856 14.4196 12.1054C14.3031 12.2253 14.2119 12.3673 14.1512 12.523C14.0905 12.6787 14.0617 12.845 14.0664 13.0121C14.0756 13.3374 14.2113 13.6462 14.4446 13.873C14.678 14.0998 14.9905 14.2267 15.3159 14.2267C15.6413 14.2267 15.9539 14.0998 16.1872 13.873C16.4206 13.6462 16.5562 13.3374 16.5654 13.0121ZM19.8084 11.7621C19.9755 11.7574 20.1418 11.7862 20.2975 11.8468C20.4533 11.9075 20.5952 11.9988 20.7151 12.1153C20.8349 12.2318 20.9302 12.3711 20.9952 12.5251C21.0603 12.679 21.0938 12.8445 21.0938 13.0116C21.0938 13.1787 21.0603 13.3441 20.9952 13.4981C20.9302 13.652 20.8349 13.7914 20.7151 13.9079C20.5952 14.0244 20.4533 14.1157 20.2975 14.1763C20.1418 14.237 19.9755 14.2658 19.8084 14.2611C19.4832 14.2519 19.1743 14.1162 18.9475 13.8829C18.7207 13.6496 18.5938 13.337 18.5938 13.0116C18.5938 12.6862 18.7207 12.3736 18.9475 12.1403C19.1743 11.907 19.4832 11.7713 19.8084 11.7621ZM21.6554 22.6741C21.311 22.2288 20.8417 21.8963 20.3074 21.7191L18.9304 21.2711C18.8246 21.2334 18.7331 21.1639 18.6684 21.0722C18.6036 20.9804 18.5689 20.8709 18.5689 20.7586C18.5689 20.6463 18.6036 20.5367 18.6684 20.445C18.7331 20.3532 18.8246 20.2837 18.9304 20.2461L20.3074 19.7981C20.7154 19.6574 21.0859 19.4256 21.3909 19.1203C21.6958 18.815 21.9272 18.4442 22.0674 18.0361L22.0774 18.0021L22.5264 16.6251C22.5639 16.5189 22.6333 16.427 22.7252 16.362C22.8171 16.297 22.9269 16.2621 23.0394 16.2621C23.152 16.2621 23.2618 16.297 23.3537 16.362C23.4455 16.427 23.515 16.5189 23.5524 16.6251L24.0004 18.0021C24.1399 18.4206 24.375 18.8009 24.6871 19.1127C24.9992 19.4244 25.3797 19.6591 25.7984 19.7981L27.1764 20.2461L27.2034 20.2531C27.3092 20.2907 27.4008 20.3602 27.4655 20.452C27.5303 20.5437 27.565 20.6533 27.565 20.7656C27.565 20.8779 27.5303 20.9874 27.4655 21.0792C27.4008 21.1709 27.3092 21.2404 27.2034 21.2781L25.8254 21.7261C25.4068 21.8652 25.0264 22.0999 24.7143 22.4117C24.4022 22.7234 24.167 23.1036 24.0274 23.5221L23.5804 24.8991C23.5423 25.0052 23.4725 25.097 23.3804 25.1621C23.3118 25.2106 23.2328 25.2426 23.1497 25.2555C23.0666 25.2684 22.9816 25.2618 22.9015 25.2363C22.8214 25.2108 22.7482 25.1671 22.6878 25.1086C22.6274 25.0501 22.5814 24.9784 22.5534 24.8991L22.1054 23.5221C22.0048 23.2159 21.8526 22.9291 21.6554 22.6741ZM29.3494 26.4751L28.5844 26.2271C28.3518 26.1498 28.1404 26.0194 27.967 25.8461C27.7936 25.6729 27.6629 25.4616 27.5854 25.2291L27.3364 24.4641C27.3157 24.405 27.2772 24.3538 27.2261 24.3176C27.1751 24.2814 27.114 24.262 27.0514 24.262C26.9888 24.262 26.9278 24.2814 26.8767 24.3176C26.8257 24.3538 26.7871 24.405 26.7664 24.4641L26.5174 25.2281C26.4417 25.4591 26.3135 25.6695 26.143 25.8428C25.9725 26.0161 25.7642 26.1476 25.5344 26.2271L24.7684 26.4751C24.7094 26.4958 24.6582 26.5343 24.622 26.5854C24.5858 26.6364 24.5663 26.6975 24.5663 26.7601C24.5663 26.8227 24.5858 26.8837 24.622 26.9348C24.6582 26.9858 24.7094 27.0244 24.7684 27.0451L25.5344 27.2941C25.7675 27.3717 25.9792 27.5027 26.1527 27.6767C26.3262 27.8506 26.4565 28.0628 26.5334 28.2961L26.7814 29.0601C26.8026 29.1187 26.8413 29.1694 26.8923 29.2052C26.9433 29.241 27.0041 29.2602 27.0664 29.2602C27.1288 29.2602 27.1896 29.241 27.2406 29.2052C27.2916 29.1694 27.3303 29.1187 27.3514 29.0601L27.6014 28.2961C27.6786 28.0634 27.8089 27.8519 27.9822 27.6785C28.1555 27.505 28.3668 27.3744 28.5994 27.2971L29.3654 27.0491C29.4245 27.0284 29.4757 26.9898 29.5119 26.9388C29.5481 26.8877 29.5675 26.8267 29.5675 26.7641C29.5675 26.7015 29.5481 26.6404 29.5119 26.5894C29.4757 26.5383 29.4245 26.4998 29.3654 26.4791L29.3494 26.4751Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_1474_554">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(5.56641 5.26208)"
            />
          </clipPath>
        </defs>
      </svg>
    )
  }
];
